/**
 * DOS518 - Digital Operations System for Wildfire Management
 * Copyright (c) 2024-2025 Angelo Irtilaç — All rights reserved.
 *
 * ASTUTOImportModal.tsx
 * Wrapper che delega al layer di integrazione unificato.
 * La logica è in: src/integrations/astuto/
 */
// src/components/Dashboard/ASTUTOImportModal.tsx
import React from 'react';
import { AstutoImport } from '../Risorse/AstutoImport';

export const ASTUTOImportModal: React.FC<{ onClose: () => void }> = ({ onClose }) => (
  <AstutoImport onClose={onClose} />
);
